import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Box, Card, CardMedia, Skeleton, Stack, Typography } from '@mui/material';
import Slider from 'react-slick'; // Import the Slider component from react-slick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useSelector } from 'react-redux';
import { useDevice } from '../hooks/useResponsive';
import useCloudinary from '../hooks/useCloudinaryImage';

ShowRoomCarousalSection.propTypes = {
  showroomsList: propTypes.any,
};
export default function ShowRoomCarousalSection({ showroomsList }) {
  const { isMobile } = useDevice();
  const { loading } = useSelector((state) => ({
    loading: state.Showroom.loading,
  }));

  // console.log(loading);
  // const CarDelivery = [
  //   {
  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  //   {
  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  //   {
  //     image: '/assets/images/ReviewCarousal/review1.png',
  //   },
  // ];
  const [currentSlide, setCurrentSlide] = useState(0);

  // Configuration for the carousel
  const settings = {
    dots: true,
    infinite: false,
    afterChange: (index) => setCurrentSlide(index),

    speed: 500,
    slidesToShow: 3.8,
    slidesToScroll: 1,

    arrows: false,
    customPaging: (i) => {
      const isActive = i === Math.round(currentSlide);
      return (
        <button type="button">
          <span
            style={{
              display: 'block',
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              backgroundColor: isActive ? '#ffffff' : '#888888',
              transition: 'all 0.3s ease',
              margin: '0 auto',
            }}
          />
        </button>
      );
    },
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          // centerMode: false,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 3.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 3.8,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Stack sx={{ maxWidth: '100%', px: isMobile ? 0 : '75px', pt: isMobile ? 4 : 11, pb: isMobile ? 2 : 11 }}>
      <Typography
        className="featured-text"
        color="#e0e0e0"
        fontSize={isMobile ? '17px' : '20px'}
        fontWeight="bolder"
        pb={isMobile ? 4.5 : 4}
        pt={isMobile && 3}
        pl={isMobile ? 1.8 : 0}
        // textAlign={isMobile ? 'left' : 'center'}
      >
        focus Showrooms{' '}
      </Typography>
      <Box
        sx={{
          maxWidth: '100%',
          px: 0,
          pl: isMobile && 1,
          pb: 4,
          // '& .slick-dots': {
          //   display: 'flex !important',
          //   justifyContent: 'center',
          //   alignItems: 'center',
          //   gap: '0px',
          //   bottom: '-20px',
          // },
          // '& .slick-dots li': {
          //   margin: '0 !important',
          // },
          // '& .slick-dots li button:before': {
          //   fontSize: '5px',
          //   color: '#888888',
          //   opacity: 1,
          // },
          // '& .slick-dots li.slick-active button:before': {
          //   color: '#ffffff',
          // },
          '& .slick-dots': {
            display: 'flex !important',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '6px',
            bottom: '-30px',
          },
          '& .slick-dots li': {
            margin: '0 !important',
          },
          '& .slick-dots li button': {
            padding: 0,
            width: 'auto',
            height: 'auto',
          },
          '& .slick-dots li button:before': {
            display: 'none', // ✅ Hides Slick's default dot
            content: 'none',
          },
        }}
      >
        {/* <Slider {...settings}>
          {showroomsList?.map((item, index) => (
            <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
              <Card className="CardTransform-feature-cars">
                {item && item?.images[0] ? (
                  <CardMedia
                    component="img"
                    src={
                      item?.images?.[0]?.url
                        ? // eslint-disable-next-line react-hooks/rules-of-hooks
                          useCloudinary(item.images[0].url, 'w_600')
                        : '/assets/images/Feature/black.png'
                    }
                    alt="Card Image"
                    sx={{ height: '112px' }}
                  />
                ) : (
                  <CardMedia component="img" src={'/assets/images/Feature/black.png'} alt="Card Image" />
                )}
              </Card>
            </Stack>
          ))}
        </Slider> */}
        <Slider {...settings} className="showroom-carousal">
          {loading
            ? [...Array(4)].map((_, index) => (
                <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
                  <Skeleton
                    variant="rectangular"
                    animation="wave"
                    height={isMobile ? 112 : '211px'}
                    width="100%"
                    sx={{ backgroundColor: '121212' }}
                  />
                </Stack>
              ))
            : showroomsList?.map((item, index) => {
                const imageUrl = item?.images?.[0]?.url
                  ? // eslint-disable-next-line react-hooks/rules-of-hooks
                    useCloudinary(item.images[0].url, 'w_400 f_auto q_auto')
                  : '/assets/images/Feature/black.png';

                const imageElement = (
                  <CardMedia
                    component="img"
                    src={imageUrl}
                    alt="Card Image"
                    sx={{ height: isMobile ? '112px' : '211px' }}
                  />
                );

                return (
                  <Stack key={index} sx={{ pl: 1, borderRadius: '8px' }}>
                    <Card className="CardTransform-feature-cars">
                      {item?.google_map_url ? (
                        <a
                          href={item.google_map_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'block', width: '100%' }}
                        >
                          {imageElement}
                        </a>
                      ) : (
                        imageElement
                      )}
                    </Card>
                  </Stack>
                );
              })}
        </Slider>
      </Box>
    </Stack>
  );
}
